export interface SlotColourFamily {
  light: string;
  dark: string;
}

/**
 * One colour family per slot-index (not per vehicle type) -- every "Slot 1"
 * column across Sedan/SUV/Wheelchair shares a hue, "Slot 2" shares the next,
 * and so on, cycling if there are ever more slots than colours. Booked cells
 * use the light shade, open/available cells use the dark shade of the same
 * hue, so a dispatcher can scan one colour family to see what's next free.
 */
export const SLOT_COLOUR_FAMILIES: SlotColourFamily[] = [
  { light: "#BFDBFE", dark: "#1D4ED8" }, // blue
  { light: "#BBF7D0", dark: "#15803D" }, // green
  { light: "#FDE68A", dark: "#B45309" }, // amber
  { light: "#DDD6FE", dark: "#6D28D9" }, // violet
  { light: "#FBCFE8", dark: "#BE185D" }, // pink
  { light: "#A5F3FC", dark: "#0E7490" }, // cyan
];

export const getSlotColourFamily = (slotIndex: number): SlotColourFamily =>
  SLOT_COLOUR_FAMILIES[slotIndex % SLOT_COLOUR_FAMILIES.length];

/**
 * Real per-(vehicle type, slot number) colour from Settings -> Vehicle Types
 * -> Slot Colours, falling back to the rotating default palette (keyed by
 * slot number) if that exact slot hasn't been configured yet -- a brand-new
 * slot always renders with a sensible colour, never blank.
 */
export const getSlotColour = (
  vehicleType: string,
  slotNumber: number,
  colours: { vehicle_type: string; slot_number: number; booked_colour_hex: string; available_colour_hex: string }[]
): SlotColourFamily => {
  const match = colours.find((c) => c.vehicle_type === vehicleType && c.slot_number === slotNumber);
  if (match) return { light: match.booked_colour_hex, dark: match.available_colour_hex };
  return getSlotColourFamily(slotNumber - 1);
};
